module.exports = __webpack_public_path__ + "static/img/devlopment.fc48b11.png";


//////////////////
// WEBPACK FOOTER
// ./static/walkInto/devlopment.png
// module id = apQJ
// module chunks = 1